import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";

import { Loader } from "@pbz/ui-kit";

import NotFound from "./pages/NotFound";
import { routeTree } from "./routeTree.gen";
import { orpc, queryClient } from "./utils/orpc-client";

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPendingComponent: () => (
    <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <Loader className="h-16 w-16 text-primary text-blue-500" />
    </div>
  ),
  context: {
    orpc,
    queryClient,
  },
  defaultNotFoundComponent: NotFound,
  Wrap({ children }: { children: React.ReactNode }) {
    return (
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    );
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWithAuth />
    </QueryClientProvider>
  );
};

// Separate component to use auth context
const AppWithAuth = () => {
  return <RouterProvider context={{ orpc, queryClient }} router={router} />;
};

export default App;
